import './styles/main.scss';
import './styles/common.scss';
import './styles/btn.scss';
import './styles/reset.scss';
// import 'antd/dist/antd.less';
// import favicon from './images/favicon.ico';
import React from 'react';
import { render } from 'react-dom';
import Root from './routes/Root';

render(<Root />, document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/index.jsx